type Props = {
  hasSeenLowTasksModalThisBillingPeriod: boolean;
  hasSeenOutOfTasksModal: boolean;
  isEligibleForLowTaskUpgradeNudge: boolean;
  isEligibleForTaskUpgradeNudge: boolean;
  isMasquerade: boolean;
};

export const getTaskLimitModalVisibility = ({
  hasSeenLowTasksModalThisBillingPeriod,
  hasSeenOutOfTasksModal,
  isEligibleForLowTaskUpgradeNudge,
  isEligibleForTaskUpgradeNudge,
  isMasquerade,
}: Props) => {
  let shouldShowModal = false;

  if (isMasquerade) {
    return false;
  }

  if (isEligibleForLowTaskUpgradeNudge) {
    shouldShowModal = !hasSeenLowTasksModalThisBillingPeriod;
  } else if (isEligibleForTaskUpgradeNudge) {
    shouldShowModal = !hasSeenOutOfTasksModal;
  }

  return shouldShowModal;
};
